"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenteredSmall = exports.StyledImage = exports.SmallImgWrap = exports.ImgWrap = exports.FixDiv = exports.ImageNode = exports.PriceInline = exports.Price = exports.SmallName = exports.InlineName = exports.Name = exports.InlineNameWrapper = exports.NameWrapper = exports.ProductWrapper = exports.ProductLink = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
exports.ProductLink = (0, app_1.styled)(app_1.Link) `
  background-color: var(--accent-1);
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  position: relative;
  width: 100%;
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.15s;
  transition-timing-function: linear;
  height: unset;
  ${(theme) => theme.fadeIn}
`;
exports.ProductWrapper = app_1.styled.div `
  position: relative;
  width: 100%;
  ${(theme) => theme.flexCenter};
  min-width: 20rem;
`;
exports.NameWrapper = app_1.styled.div `
  position: absolute;
  top: 0;
  left: 0;
  min-width: 30%;
  max-width: 70%;
  z-index: 1;
`;
exports.InlineNameWrapper = app_1.styled.div `
  width: 100%;
  background: ${(theme) => theme.colors.primary};
`;
exports.Name = (0, app_1.styled)(ui_1.TextWrapFitter) `
  padding: ${(theme) => `${theme.spacing.extraSmall} ${theme.spacing.small}`};
  background: ${(theme) => theme.colors.secondary};
  font-weight: 400;
  width: 100%;
  > span {
    max-width: 7rem;
  }
`;
exports.InlineName = (0, app_1.styled)(app_1.Text) `
  padding: ${(theme) => `${theme.spacing.extraSmall} ${theme.spacing.small}`};
  color: ${(theme) => theme.colors.secondary};
  font-weight: 400;
  font-size: 1.5rem;
  line-height: 1.875rem;
  width: 100%;
`;
exports.SmallName = (0, app_1.styled)(ui_1.TextWrapFitter) `
  margin: auto;
  padding: ${(theme) => theme.spacing.small};
  z-index: 1;
  font-size: 0.875rem;
  line-height: 100%;
  max-width: 13rem;
  background: white;
  letter-spacing: 0.175rem;
  @media ${app_1.mobile} {
    text-align: center;
  }
`;
exports.Price = app_1.styled.span `
  padding: ${(theme) => `${theme.spacing.extraSmall} ${theme.spacing.small}`};
  width: max-content;
  display: ${(_, { $hidden }) => ($hidden ? 'none' : 'block')};
  > span {
    width: 3rem;
  }
`;
exports.PriceInline = app_1.styled.div `
  display: ${(_, { $hidden }) => ($hidden ? 'none' : 'block')};
`;
exports.ImageNode = app_1.styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  max-height: 100%;
  height: 100%;
`;
exports.FixDiv = app_1.styled.div `
  display: block;
  position: relative;
  width: 100%;
  padding-top: 100%;
  > div {
    position: absolute;
    top: 0;
  }
`;
exports.ImgWrap = app_1.styled.div `
  display: block;
  overflow: hidden;
  position: relative;
  margin: 0px;
  min-width: 100%;
  max-height: 100%;
  height: 100%;
`;
exports.SmallImgWrap = app_1.styled.div `
  overflow: hidden;
  display: inline-block;
  position: relative;
  width: 20rem;
  height: 20rem;
  > img {
    object-fit: cover;
  }
`;
exports.StyledImage = (0, app_1.styled)(app_1.Image) `
  transition: 500ms all;
  object-fit: contain;
  :hover {
    transform: scale(1.05);
  }
`;
exports.CenteredSmall = (0, app_1.styled)(ui_1.Stack) `
  align-items: center;
`;
